import HeadBlock from "../components/HeadBlock";
import Header from "../components/Header";
import Nav from "../components/Nav";
import iconStyles from "../assets/styles/icon.module.scss";
import styles from "../assets/styles/subscription.module.scss";
import SubscriptionText from "../assets/images/subscription_text.png";
import SubscriptionKV from "../assets/images/subscription_kv.png";
import SPSubscriptionDescription from "../assets/images/sp_subscription_description.png";
import PCSubscriptionDescription from "../assets/images/pc_subscription_description.png";
import { useAuthContext } from "../components/AuthContext";
import { SigninModal } from "../components/SigninModal";
import { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const Subscription = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user, isSubscribed } = useAuthContext();
  const [shownModalSignin, setShownModalSignin] = useState<string | null>(null);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (!user) {
      setShownModalSignin("subscription");
      return;
    }

    try {
      setIsLoading(true);
      const checkoutSession = httpsCallable<
        {
          uid: string;
        },
        {
          checkoutUrl: string | null;
        }
      >(functions, "createSubscriptionCheckoutSession");

      const { data } = await checkoutSession({
        uid: user.uid,
      });

      if (data?.checkoutUrl) {
        window.location.href = data.checkoutUrl;
      }
    } catch (error) {
      console.error("Error creating subscription checkout session:", error);
      alert("エラーが発生しました。");
    } finally {
      setIsLoading(false);
    }
  };

  const onClickToCustomerPortal = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    setIsLoading(true);

    if (isSubscribed) {
      try {
        const createCustomerPortalUrl = httpsCallable<
          unknown,
          { url: string | null }
        >(functions, "createCustomerPortalUrl");
        const { data } = await createCustomerPortalUrl({
          uid: user?.uid,
        });

        if (!data) {
          alert("エラーが発生しました。");
        }

        if (data?.url) {
          window.location.href = data.url;
        }
      } catch (error) {
        console.error("Error creating customer portal URL:", error);
        alert("エラーが発生しました。");
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <HeadBlock title={"聴き放題プランの紹介"} path="" />
      <Header />
      {shownModalSignin && (
        <SigninModal
          setShownModalSignin={setShownModalSignin}
          shownModalSignin={shownModalSignin}
          redirectUrl="/subscription"
        />
      )}

      <div className={styles.container}>
        <div className={styles.background}>
          <img
            src={require("../assets/images/bk_img_top.png")}
            className={styles.image}
            alt="subscription-top"
          />
          <img
            src={require("../assets/images/bk_img_bottom.png")}
            className={styles.image}
            alt="subscription-bottom"
          />
        </div>

        <div className={styles.foreground}>
          <div className={styles.container}>
            <img
              className={styles.heading_text_image}
              src={SubscriptionText}
              alt=""
            />
            <p className={styles.copy_text}>
              まだ知らない<span>”推し”</span>が、ここにいる。
            </p>
            <p className={styles.copy_text}>
              PAZLEの聴き放題で、
              <wbr className={styles.break_sp} />
              新たな出会いをーー
            </p>

            <img
              className={styles.kv}
              src={SubscriptionKV}
              alt="subscription_kv"
            />
            <img
              className={styles.sp_description}
              src={SPSubscriptionDescription}
              alt="subscription_description"
            />

            <img
              className={styles.pc_description}
              src={PCSubscriptionDescription}
              alt="subscription_description"
            />

            {!isSubscribed ? (
              <button
                type="button"
                className={styles.btn}
                onClick={handleClick}
                disabled={isLoading}
              >
                <i className={iconStyles.icon_subscription}></i>
                聴き放題で楽しむ（月額￥500）
              </button>
            ) : (
              <button
                type="button"
                className={styles.btn}
                onClick={onClickToCustomerPortal}
                disabled={isLoading}
              >
                <i className={iconStyles.icon_subscription}></i>
                聴き放題プランを管理する
              </button>
            )}
          </div>
        </div>
      </div>

      <Nav />
    </>
  );
};
